import React, { Component } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, SearchIcon, PlusSquareIcon, BellIcon, UserIcon } from 'lucide-react';
const BottomNavigation = () => {
  const location = useLocation();
  const navItems = [{
    icon: HomeIcon,
    path: '/',
    label: 'Home'
  }, {
    icon: SearchIcon,
    path: '/discover',
    label: 'Discover'
  }, {
    icon: PlusSquareIcon,
    path: '/create',
    label: 'Post'
  }, {
    icon: BellIcon,
    path: '/notifications',
    label: 'Alerts'
  }, {
    icon: UserIcon,
    path: '/profile',
    label: 'Profile'
  }];
  return <div className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-white border-t border-gray-200 flex justify-around items-center h-16 px-2 rounded-b-3xl shadow-lg" data-id="element-385">
      {navItems.map(item => {
      const isActive = location.pathname === item.path;
      const IconComponent = item.icon;
      return <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center w-1/5 py-1 
              ${isActive ? 'text-green-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-386">
            <IconComponent size={22} strokeWidth={isActive ? 2.5 : 1.5} className={isActive ? 'fill-green-100' : ''} data-id="element-387" />
            <span className="text-xs mt-1 font-medium" data-id="element-388">{item.label}</span>
          </Link>;
    })}
    </div>;
};
export default BottomNavigation;